import m from "../../es2015/lang/cs_CZ";
window.am4lang_cs_CZ = m;


//////////////////
// WEBPACK FOOTER
// ./lang/cs_CZ.js
// module id = null
// module chunks = 